import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Site error boundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-[#FDFBF7] px-6 text-center" data-testid="error-boundary-fallback">
          <p className="font-display text-3xl text-[#1A1A1A] md:text-4xl">Something went wrong.</p>
          <p className="mt-4 max-w-md text-base font-light text-[#1A1A1A]/70">
            Please refresh, or WhatsApp us at +91 92055 11502
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
